const toNights = (value) => {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n >= 0 ? n : 0;
};

const isStay = (stop) => toNights(stop?.nights) >= 1;

const toBaseRef = (source, kind) => {
  if (!source) return null;
  return {
    name: source.name ?? null,
    lat: source.lat ?? source.latitude ?? null,
    lon: source.lon ?? source.longitude ?? null,
    kind,
  };
};

const findStayBackward = (stops, fromIndex) => {
  for (let i = fromIndex - 1; i >= 0; i -= 1) {
    if (isStay(stops[i])) return stops[i];
  }
  return null;
};

const findStayForward = (stops, fromIndex) => {
  for (let i = fromIndex + 1; i < stops.length; i += 1) {
    if (isStay(stops[i])) return stops[i];
  }
  return null;
};

const stopRefId = (stop, index) => stop?.id ?? `stop_${index}`;

const buildClusterMap = (stops) => {
  const map = new Map();
  let cursor = 0;

  while (cursor < stops.length) {
    if (toNights(stops[cursor]?.nights) !== 0) {
      cursor += 1;
      continue;
    }

    const startIdx = cursor;
    while (cursor < stops.length && toNights(stops[cursor]?.nights) === 0) {
      cursor += 1;
    }
    const endIdx = cursor - 1;

    const memberIds = [];
    for (let i = startIdx; i <= endIdx; i += 1) {
      memberIds.push(stopRefId(stops[i], i));
    }

    const clusterId = `cluster_${startIdx}`;
    const size = endIdx - startIdx + 1;

    for (let i = startIdx; i <= endIdx; i += 1) {
      map.set(i, {
        id: clusterId,
        size,
        index: i - startIdx,
        isFirst: i === startIdx,
        isLast: i === endIdx,
        memberIds,
      });
    }
  }

  return map;
};

export const inferBases = ({ origin, stops } = {}) => {
  if (!Array.isArray(stops) || stops.length === 0) return [];

  const originRef = toBaseRef(origin, "origin");
  const clusterMap = buildClusterMap(stops);

  return stops.map((stop, index) => {
    const nights = toNights(stop?.nights);

    if (nights >= 1) {
      return {
        ...stop,
        nights,
        kind: "stay",
        baseBefore: null,
        baseAfter: null,
        cluster: null,
      };
    }

    const prevStay = findStayBackward(stops, index);
    const nextStay = findStayForward(stops, index);

    const baseBefore = prevStay ? toBaseRef(prevStay, "stay") : originRef;
    const baseAfter = nextStay ? toBaseRef(nextStay, "stay") : originRef;

    return {
      ...stop,
      nights: 0,
      kind: "day_trip",
      baseBefore,
      baseAfter,
      cluster: clusterMap.get(index) ?? null,
    };
  });
};

export default inferBases;
